import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "42",
  viewBox: "0 0 42 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 37.088L37.088 0l4.428 4.429L4.43 41.517z" }, null, -1),
    _createElementVNode("path", { d: "M4.429 0l37.088 37.088-4.429 4.429L0 4.429z" }, null, -1)
  ]))]))
}
export default { render: render }